import { Box, Connection, ConnectionStop, Skeleton } from "@flixbus/honeycomb-react";
import cx from "classnames";
import * as React from "react";
import * as css from "./RideListPageSkeleton.scss";

const RideListPageSkeleton: React.FC = () => (
  <Box small>
    <Skeleton flushBottom height="md" extraClasses={css.editButton} />

    <div className={css.grid}>
      <div className={css.statusAndLineCode}>
        <Skeleton round flushBottom height="md" extraClasses={css.statusAndLineCodeItem} />
        <Skeleton round flushBottom height="md" extraClasses={css.statusAndLineCodeItem} />
      </div>

      <div className={css.date}>
        <Skeleton round flushBottom height="md" extraClasses={css.label} />
        <Skeleton flushBottom height="md" extraClasses={cx(css.value, css.valueLong)} />
      </div>

      <div className={css.route}>
        <Skeleton flushBottom height="md" extraClasses={css.label} />
        <Connection extraClasses={css.connection}>
          <ConnectionStop
            extraClasses="alex"
            station={<Skeleton flushBottom height="md" extraClasses={css.skeleton} />}
            time=""
          />
          <ConnectionStop
            extraClasses="munich"
            station={<Skeleton flushBottom height="md" extraClasses={css.skeleton} />}
            time=""
          />
        </Connection>
      </div>

      <div className={css.pax}>
        <Skeleton flushBottom height="md" extraClasses={css.label} />
        <Skeleton flushBottom height="md" extraClasses={cx(css.value, css.valueShort)} />
      </div>

      <div className={css.seats}>
        <Skeleton flushBottom height="md" extraClasses={css.label} />
        <Skeleton flushBottom height="md" extraClasses={cx(css.value, css.valueShort)} />
      </div>
    </div>

    <Skeleton flushBottom height="md" extraClasses={css.checkInButton} />
  </Box>
);

export default RideListPageSkeleton;
